<div class="address-edit-container">
  <div class="row px-4">
    <p class="col-12 p-0">
      Veuillez sélectionner l’adresse exacte qui sera utilisée pour déduire le
      périmètre des statistiques de marché :
    </p>
    <div class="col-6 position-relative p-0">
      <form id="adresse-form" [formGroup]="addressForm">
        <p-input
          [formControl]="addressForm.controls.addressInput"
          id="adresseInput"
          name="adresseInput"
          label="Adresse"
          (input)="addressInputChanged($event)"
          (mouseenter)="onAddressInputMouseEnter()"
          [helpTextRight]="addressInputCustomMessage"
        ></p-input>
      </form>
      <div class="position-absolute top-100 start-0 bg-white w-100">
        <p-autocomplete
          [itemsInputAutoCompletion]="
            addressInputAutoCompletion | arrayFieldGetter: 'label'
          "
          [inputValue]="addressForm.controls.addressInput.value"
          (autocompletionSelected)="onAutocompletionSelected($event)"
        ></p-autocomplete>
      </div>
    </div>
    <ng-container *ngIf="geoInfoRead">
      <div class="col-1 d-flex justify-content-center">
        <p-vertical-separator height="70px"></p-vertical-separator>
      </div>
      <div class="col-5">
        <p class="fs-7 m-0">Votre choix correspond à :</p>
        <ul list-testid="autocomplete-list" class="fs-7">
          <li
            *ngIf="
              geoInfoRead.districtLabel &&
              (autocompleteSelectedAddress?.type === 'street' ||
                autocompleteSelectedAddress?.type === 'housenumber')
            "
          >
            Quartier :
            <span class="fw-bold">{{ geoInfoRead.districtLabel }}</span>
          </li>
          <li *ngIf="geoInfoRead.cityLabel">
            Commune : <span class="fw-bold">{{ geoInfoRead.cityLabel }}</span>
          </li>
          <li *ngIf="geoInfoRead.epciLabel">
            EPCI : <span class="fw-bold">{{ geoInfoRead.epciLabel }}</span>
          </li>
          <li *ngIf="geoInfoRead.departementLabel">
            Département :
            <span class="fw-bold">{{ geoInfoRead.departementLabel }}</span>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
</div>
